var render = function render() {
  var _vm = this,
      _c = _vm._self._c;return _c('div', { staticClass: "report-container" }, [_c('el-menu', { staticClass: "el-menu-demo", attrs: { "default-active": _vm.activeIndex, "mode": "horizontal", "router": "" } }, [_c('el-menu-item', { attrs: { "index": "auth" } }, [_vm._v("广告审核报表")]), _vm._v(" "), _c('el-menu-item', { attrs: { "index": "plan" } }, [_vm._v("高风险广告主列表")]), _vm._v(" "), _c('el-menu-item', { attrs: { "index": "product" } }, [_vm._v("高风险产品标签列表")])], 1), _vm._v(" "), _c('router-view')], 1);
};
var staticRenderFns = [];

export { render, staticRenderFns };